import { NotFound, ProtectedRoute } from "@fdoh/health-ui-react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import HomePage from "../Home/Home";

export const HomeModule = () => {
  let { path } = useRouteMatch();

  return (
    
      <Switch>
        <ProtectedRoute exact path={path}>
              <HomePage />
        </ProtectedRoute>
        <Route>
          <NotFound />
        </Route>
      </Switch>
    
  );
};

export default HomeModule;
